export default __webpack_public_path__ + "static/media/1022.add06f40.png";